import { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import AuthContext from "common/store/AuthContext";
import { createDocumentTitle } from "utils/commonTools";
import { DashboardTemplate } from "common/components/templates/DashboardTemplate";
import FormContainer from "common/components/templates/FormContainer";
import { SimpleTopBar } from "common/components/organisms/SimpleTopBar";
import { BaseForm } from "common/components/templates/BaseForm";
import { SelectYearMonthControl } from "pages/print/components/molecules/SelectYearMonthControl";
import { Col, Row } from "react-bootstrap";
import { ReportListPanel } from "./ReportListPanel";
import { REPORT_TYPE } from "common/types/consts/Defines";

export const ReportMaintenancePage = (props: { pageTitle: string }) => {
  const { selectedPark } = useContext(AuthContext);
  const [yearMonth, setYearMonth] = useState(new Date());

  useEffect(() => {
    document.title = createDocumentTitle(props.pageTitle);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <DashboardTemplate>
      <FormContainer size="max">
        {!selectedPark ? (
          <div> 公園が選択されていません </div>
        ) : !selectedPark.isAdmin ? (
          <div>管理者以外は利用できません</div>
        ) : (
          <>
            <SimpleTopBar parkName={selectedPark.parkName ?? ""} pageTitle={props.pageTitle} />

            <BaseForm className="p-3">
              <SelectYearMonthControl
                yearMonth={yearMonth}
                changed={(newData) => {
                  setYearMonth(newData);
                }}
              />
              <Row>
                <SCol xl={6}>
                  <ReportListPanel
                    reportType={REPORT_TYPE.DAILY}
                    yearMonth={yearMonth}
                    title="公園日報"
                  />
                </SCol>
                <Col xl={6}>
                  <ReportListPanel
                    reportType={REPORT_TYPE.WORK}
                    yearMonth={yearMonth}
                    title="作業日報"
                  />
                </Col>
              </Row>
            </BaseForm>
          </>
        )}
      </FormContainer>
    </DashboardTemplate>
  );
};

const SCol = styled(Col)`
  max-width: 600px;
`;
